import { Box, IconButton, Typography } from '@mui/material';
import { Component } from 'react';
import AddIcon from '@mui/icons-material/Add';
import SingleFile from './SingleFile';

class SingleUploadComponent extends Component {
    // file, handleFileUpload, onOpenPopover, handleInput

    render() {
        return (
            <Box
                display="flex"
                alignItems="center"
                p={this.props.file ? 0 : 2}
            >
                {!this.props.file && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        align="center"
                    >
                        Please upload a file
                    </Typography>
                )}

                {this.props.file && (
                    <SingleFile
                        file={this.props.file}
                        fieldFileType={this.props.fieldFileType}
                        fileTypes={this.props.fileTypes}
                        handleInput={this.props.handleInput}
                        onOpenPopover={this.props.onOpenPopover}
                        inputFileType={this.props.inputFileType}
                    />
                )}

                {!this.props.file && (
                    <Box alignItems="center" flexBasis="content">
                        <IconButton
                            sx={{ marginX: 1 }}
                            onClick={(event) => this.fileUpload.click()}
                        >
                            <AddIcon />
                            <input
                                type="file"
                                accept="*/*"
                                hidden
                                ref={(fileUpload) => {
                                    this.fileUpload = fileUpload;
                                }}
                                onChange={(event) =>
                                    this.props.handleFileUpload(event)
                                }
                            />
                        </IconButton>
                    </Box>
                )}
            </Box>
        );
    }
}

export default SingleUploadComponent;
